module.exports = __webpack_public_path__ + "static/media/logo.10d76666.png";